import { Auth } from "aws-amplify";
import AWS from "aws-sdk";
import pako from "pako";
import awsconfig from "../aws-exports";

import store from "../store";

export default async function pollState() {
  const SQS = new AWS.SQS({
    region: awsconfig.aws_project_region
  });

  while (store.state.pollState) {
    if (!SQS.config.credentials || SQS.config.credentials.expired) {
      console.log("Refreshing credentials");

      const credentials = await Auth.currentUserCredentials();
      SQS.config.credentials = Auth.essentialCredentials(credentials);
    }

    const stateResponse = await SQS.receiveMessage({
      QueueUrl: awsconfig.state_queue_url,
      MaxNumberOfMessages: 10,
      WaitTimeSeconds: 20,
      MessageAttributeNames: ["All"]
    }).promise();

    const messages = stateResponse.Messages;
    if (!messages || messages.length === 0) continue;

    await SQS.deleteMessageBatch({
      QueueUrl: awsconfig.state_queue_url,
      Entries: messages.map((message, index) => ({
        Id: index.toString(),
        ReceiptHandle: message.ReceiptHandle
      }))
    }).promise();

    for (const msg of messages) {
      const botName = msg.MessageAttributes.bot.StringValue;

      const decoded = atob(msg.Body);
      const split = decoded.split("").map(x => x.charCodeAt(0));

      const binData = new Uint8Array(split);
      const decompressed = pako.inflate(binData, { to: "string" });

      store.commit("botState", {
        name: botName,
        value: JSON.parse(decompressed)
      });

      const bRaw = localStorage.getItem("bots") || "{}";
      const bots = JSON.parse(bRaw);
      bots[botName] = true;
      localStorage.setItem("bots", JSON.stringify(bots));
    }
  }
}
